module.exports = __webpack_public_path__ + "img/zfcg_15.6cdd7d76.png";